module.exports = __webpack_public_path__ + "img/add_button.8c55606f.svg";